var map = {
	"./finish_01_LAN.mp4": 8686,
	"./process-shape-freeze_01_LAN.mp4": 5553,
	"./process-shape-freeze_02_LAN.mp4": 58,
	"./process-shape-freeze_03_LAN.mp4": 94,
	"./toast_01.jpg": 3065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8467;